module.exports = __webpack_public_path__ + "media/images/flags/4x3/sen-12a64e97a2448a1a15f950611abfe468.svg";